import React from 'react';
import { CitySearch } from './CitySearch';
import { ImageWithFallback } from './ImageWithFallback';

export function Hero() {
  return (
    <div className="relative bg-blue-600 py-24">
      <div className="absolute inset-0">
        <ImageWithFallback
          src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80"
          alt="Plumbing background"
          className="w-full h-full object-cover opacity-20"
          sizes="100vw"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl">
            Find Trusted Local Plumbers
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-100 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            24/7 Emergency Service • Licensed & Insured • Fair Pricing
          </p>
          <div className="mt-10">
            <CitySearch />
          </div>
        </div>
      </div>
    </div>
  );
}